import React from 'react';
import { useTranslation } from '../useTranslation';
import { jsx as ___EmotionJSX } from "@emotion/react";
var HARDCODED_TITLES = ['hint', 'solution', 'incorrect'];

var Title = function Title(_ref) {
  var title = _ref.title;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return ___EmotionJSX("h6", {
    className: "dc-sct-feedback__title"
  }, HARDCODED_TITLES.includes(title.toLowerCase()) ? t("FeedbacksTitle.".concat(title.toLowerCase())) : title);
};

export default Title;